/**
 * Do not change! File was auto generated.
 *
 */
import React from "react"
import { ReactComponent as BadgeNotificationComponent } from "./BadgeNotification.svg"
import Icon from "../Icon"

export const BadgeNotification = (props) => (
  <Icon {...props}>
    <BadgeNotificationComponent />
  </Icon>
)
BadgeNotification.propTypes = Icon.propTypes
